module.exports = __webpack_public_path__ + "static/media/whisky-pour--desktop.3f217950.gif";